import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Feed from "./pages/Feed";
import CreateGroup from "./pages/CreateGroup";
import CreateEvent from "./components/CreateEvent";
import SetUsername from "./components/SetUsername";
import BranchFeed from "./components/BranchFeed";
import ClubFeed from "./components/ClubFeed";
import ClubsList from "./components/ClubsList";
import Profile from "./pages/Profile";
import SettingsPage from "./pages/SettingsPage";
import CreateClub from "./components/CreateClub";
import Groups from "./components/Groups";
import MainLayout from "./components/MainLayout";
import { AuthProvider } from "./contexts/AuthContext";
import RequireAuth from "./components/RequireAuth";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Auth Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Protected Routes */}
          <Route
            path="/feed"
            element={
              <RequireAuth>
                <MainLayout>
                  <Feed />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/set-username"
            element={
              <RequireAuth>
                <MainLayout>
                  <SetUsername />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/profile/:email"
            element={
              <RequireAuth>
                <MainLayout>
                  <Profile />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <MainLayout>
                  <SettingsPage />
                </MainLayout>
              </RequireAuth>
            }
          />

          {/* Branch Routes */}
          <Route
            path="/branch/:branchCode"
            element={
              <RequireAuth>
                <MainLayout>
                  <BranchFeed />
                </MainLayout>
              </RequireAuth>
            }
          />

          {/* Club Routes */}
          <Route
            path="/clubs"
            element={
              <RequireAuth>
                <MainLayout>
                  <ClubsList />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/create-group"
            element={
              <RequireAuth>
                <MainLayout>
                  <CreateGroup />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/create-club"
            element={
              <RequireAuth>
                <MainLayout>
                  <CreateClub />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/club/:clubId"
            element={
              <RequireAuth>
                <MainLayout>
                  <ClubFeed />
                </MainLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/club/:clubId/create-event"
            element={
              <RequireAuth>
                <MainLayout>
                  <CreateEvent />
                </MainLayout>
              </RequireAuth>
            }
          />

          {/* Groups/Messaging Route */}
          <Route
            path="/groups"
            element={
              <RequireAuth>
                <MainLayout>
                  <Groups />
                </MainLayout>
              </RequireAuth>
            }
          />

          {/* 
          // Comment out until we create these components:
          <Route path="/events" element={<EventsPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          */}

          {/* 404 Route */}
          <Route path="*" element={<div>404 - Page Not Found</div>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;